import { GIT_PROVIDERS } from './constants';
import {
  LBAzureIcon,
  LBBitbucketIcon,
  LBGithubIcon,
  LBGitlabIcon
} from '@linearb/buzz';

/**
 * GitTypes - types of available git services
 */
const GitTypes = {
  GITHUB: 'github',
  GITLAB: 'gitlab',
  BITBUCKET: 'bitbucket',
  AZURE_DEVOPS: 'azure_devops'
};

export const MAP_GIT_PROVIDERS = {
  [GIT_PROVIDERS.GITHUB]: {
    name: 'Github',
    logo: LBGithubIcon
  },
  [GIT_PROVIDERS.GITLAB]: {
    name: 'Gitlab',
    logo: LBGitlabIcon
  },
  [GIT_PROVIDERS.BITBUCKET]: {
    name: 'Bitbucket',
    logo: LBBitbucketIcon
  },
  [GIT_PROVIDERS.BITBUCKET_SERVER]: {
    name: 'Bitbucket Server',
    logo: LBBitbucketIcon
  },
  [GIT_PROVIDERS.AZURE_DEVOPS]: {
    name: 'Azure DevOps',
    logo: LBAzureIcon
  }
};

export default GitTypes;
